import * as ng from 'angular';
import { ISiteConfigService } from '../../../core';
import { IToken } from '../data/interfaces';
//import { ISessionService } from '../../../services';

let AuthServiceFactory: Function = function ($window: ng.IWindowService,
    $q: ng.IQService, $httpParamSerializer: ng.IHttpParamSerializer,
    SiteConfig: ISiteConfigService): IAuthService {
    return new AuthService($window, $q, $httpParamSerializer, SiteConfig);
}

AuthServiceFactory.$inject = ['$window', '$q', '$httpParamSerializer', 'SiteConfig'];

let Auth = {
    name: "Auth",
    factory: AuthServiceFactory
};

interface IAuthService {
    initTokens(): void;
    commitTokens(tokens): void;
    clearTokens(): void;
    storeTokens(tokenKey, token): void;
    getToken(tokenKey): IToken;
    getTokenForUrlAsync(uri): ng.IPromise<any>;
    getUserTokenAsync(clientId, scope, username, password): ng.IPromise<any>;
    getClientTokenAsync(clientId, scope): ng.IPromise<any>;
    getUserRefreshTokenAsync(clientId): void;
    getUserClaims(token): Map<string, Object>;
}

export class AuthService implements IAuthService {

    private initInjector = ng.injector(['ng']);
    private $http = this.initInjector.get('$http');
    private tokens = {};
    private sessionKey = "tokens";



    constructor(private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $httpParamSerializer: ng.IHttpParamSerializer,
        private SiteConfig: ISiteConfigService) {

        this.initTokens();

    }

    public initTokens(): void {
        var tokenStr = this.$window.sessionStorage.getItem(this.sessionKey);
        if (tokenStr && tokenStr.length > 0) {
            this.tokens = JSON.parse(tokenStr);
        }
        else {
            this.tokens = {};
        }
    }

    public commitTokens(tokens): void {
        setTimeout(() => {
            this.$window.sessionStorage.setItem(this.sessionKey, JSON.stringify(tokens));
        }, 1);
    }

    public clearTokens(): void {
        this.tokens = {};
        this.$window.sessionStorage.removeItem(this.sessionKey);
    }

    public storeTokens(tokenKey, token): void {
        this.tokens[tokenKey] = token;
        this.commitTokens(this.tokens);
    }

    public getToken(tokenKey): IToken {
        if (this.tokens) {
            return this.tokens[tokenKey] || null;
        }

        return null;
    }

    public getTokenForUrlAsync(uri): ng.IPromise<any> {
     
        return this.SiteConfig.getConfigAsync()
            .then(() => {

                var match = this.SiteConfig.getUriMatch(uri);
                if (match) {                   
                    var client = this.SiteConfig.getClientById(match.clientId);
                    if (client) {
                        var tokenKey = client.id + ":" + match.scope;
                        var existingToken = this.getToken(tokenKey);
                        if (existingToken) {
                            var oneMinuteMs = 1000 * 60;
                            var currentDate = new Date().getTime();
                            var retrievedAt = new Date(existingToken.retrievedAt).getTime();
                            var elapsed = Math.round((currentDate - retrievedAt) / oneMinuteMs);

                            if (1 <= elapsed && (2 >= elapsed)) {
                                // elapsed token retrieved time is within acceptable timeframe of expring.  
                                // renew to avoid theme retrieval from getting 401.
                                return this.getClientTokenAsync(client.id, match.scope)
                                    .then((token) => {
                                        return this.$q.resolve({ tokenRequired: true, token: token.accessToken, expiresIn: token.expiresIn, retrievedAt: token.retrievedAt });
                                    });
                            }
                            else {
                                return this.$q.resolve({ tokenRequired: true, token: existingToken.accessToken, expiresIn: existingToken.expiresIn, retrievedAt: existingToken.retrievedAt });
                            }

                            //return this.$q.resolve({ tokenRequired: true, token: existingToken.accessToken, expiresIn: existingToken.expiresIn, retrievedAt: existingToken.retrievedAt });


                        }
                        else if (client.type === "app") {
                            return this.getClientTokenAsync(client.id, match.scope)
                                .then((token) => {
                                    return this.$q.resolve({ tokenRequired: true, token: token.accessToken, expiresIn: token.expiresIn, retrievedAt: token.retrievedAt  });
                                });
                        }
                        else {
                            return this.$q.resolve({ tokenRequired: true });
                        }
                    }
                }
                else {
                    return this.$q.resolve({ tokenRequired: false });
                }
            });
    }

    public getUserTokenAsync(clientId, scope, username, password): ng.IPromise<IToken> {
        return this.SiteConfig.getConfigAsync()
            .then(() => {
                return this.$http({
                    method: 'post',
                    url: this.SiteConfig.getResourceUri("token"),
                    data: this.$httpParamSerializer({
                        username: username,
                        password: password,
                        grant_type: 'password',
                        scope: scope
                    }),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Basic ' + this.SiteConfig.getClientAuthCode(clientId)
                    }
                }).then((response: any) => {
                    let data = response.data;
                    let tokenKey = clientId + ":" + scope;
                    let token = this.deserializeToken(tokenKey, data.access_token);
                    this.storeTokens(tokenKey, token);
                    return this.$q.resolve(token);

                }).catch((e) => {
                    //let status = e.status;
                    if (e.status === 400) {
                        return this.$q.reject({ isBadCredentials: true });
                    } else {
                        console.log('Login error: ' + status);
                        return this.$q.reject({ error: 'Login error: ' + status });
                    }
                });
            });
    }

    public getClientTokenAsync(clientId, scope): ng.IPromise<any> {
      
        return this.SiteConfig.getConfigAsync()
            .then(() => {

                return this.$http({
                    method: 'post',
                    url: this.SiteConfig.getResourceUri("token"),
                    data: this.$httpParamSerializer({
                        grant_type: 'client_credentials',
                        scope: scope
                    }),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Basic ' + this.SiteConfig.getClientAuthCode(clientId)
                    }
                }).then((response) => {
                    let data = response.data as any;
                    var tokenKey = clientId + ":" + scope;
                    let token = {
                        accessToken: data.access_token,
                        expiresIn: data.expires_in,
                        retrievedAt: new Date(),
                        key: clientId + ":" + scope,
                        tokenType: "Client"
                    } as IToken;
                    this.storeTokens(tokenKey, token);
                    return this.$q.resolve(token);
                }).catch((e) => {
                    if (e.status === 400) {
                        return this.$q.reject({ isBadCredentials: true });
                    } else {
                        console.log('Client Credentials Error: ' + e.status);
                        return this.$q.reject({ error: 'Client Credential error: ' + e.status });                      
                    }
                });
            });


    }

    public getUserRefreshTokenAsync(clientId): void {

    }

    private deserializeToken(tokenKey: string, accessToken?: string): IToken {
        let token = {
            key: tokenKey,
            accessToken: accessToken,
            tokenType: 'User'
        } as IToken;

        let tokenParts = accessToken.split(".");
        if (tokenParts.length > 0) {
            token.issuer = JSON.parse(atob(tokenParts[0]));
        }
        if (tokenParts.length > 1) {
            token.claims = JSON.parse(atob(tokenParts[1]));
        }

        if (tokenParts.length > 2) {
            token.md5 = tokenParts[2];
        }

        return token;
    }

    public getUserClaims(token): Map<string, Object> {
        let urArr = token.split(".");
        if (urArr.length > 1) {
            return JSON.parse(atob(urArr[1]));
        }
        throw "Token unparsable";

    }
}

export { Auth, IAuthService };
export default Auth;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/services/authorization.ts